import { watch } from 'vue'
import { useAuthStore } from '@/features/account/session'
import { usePersonasStore } from '@/features/personas/store'

export function usePersonasSession() {
  const auth = useAuthStore()
  const personas = usePersonasStore()
  watch(() => auth.userId, id => {
    personas.setAccount(id)
    if (id) void personas.fetchPersonas().catch(() => {})
  }, { immediate: true, flush: 'sync' })
}
